//ANGULAR
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageBoxService } from '../../../core/services/message-box.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query
} from '@angular/animations';
import { MessageBox } from '../../interfaces/message-box';

@Component({
    selector: 'message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    animations: [
      trigger('mbState', [
        state('* => *', style({
          transform: 'translateX(0)'
        })),
        state(':leave',   style({
          opacity: 0
        })),
        transition(':enter', [animate('1000ms ease-out')]),
        transition(':leave', [animate('1000ms ease-in')])
      ])
    ]
})
export class MessageBoxComponent implements OnInit {

    subscription: Subscription;
    messageBoxList: MessageBox[] = [];

    constructor(private _messageBoxService: MessageBoxService) { }

    ngOnInit() {
      //SUBSCRIBTION TIL MESSAGEBOKS SERVICE
      this.subscription = this._messageBoxService.messageText$.subscribe((messageBox:   MessageBox[]) => {
          if (!messageBox) { return null; }
          this.messageBoxList = messageBox;
      })
    }
    //NEDTAG SUBSCRIBTION
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    //TILFØJ MESSAGE BOKS
    addMessageBox(messageBox) {
        this.messageBoxList.splice(0, 0, messageBox);

       
    }
    //FJERN MESSAGE BOKS
    resetMessageBox(i) {
      this.messageBoxList.splice(i, 1);
    }
}